import { render, staticRenderFns } from "./CompetitionTabs.vue?vue&type=template&id=4136086b&"
import script from "./CompetitionTabs.vue?vue&type=script&lang=js&"
export * from "./CompetitionTabs.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports